import actions from './actions'
import mutations from './mutations'

const refRegister = {
    namespaced: true,
    state: {
        isReferralCodeExist: null,
        refStatus: null,
        confirmedLength: null,
        formattedPhone: null,
        sessionToken: null,
        referralCode: null
    },
    mutations,
    actions
}

export default refRegister
